import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';
import { Location } from '@freelancer/location';
import { ABTest } from './abtest.service';

@Injectable({
  providedIn: 'root',
})
export class ABTestOverridesGuard implements CanActivate {
  constructor(private abtest: ABTest, private location: Location) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const { searchParams } = new URL(this.location.href);
    const overridesParam = searchParams.get('overrides');

    if (overridesParam) {
      this.abtest.setOverridesMap(overridesParam);
    }

    if (searchParams.has('no_abtest')) {
      this.abtest.setGlobalOptOut(true);
    }
    return true;
  }
}
